module.exports = "<div class=\"form-group\" [formGroup]=\"form\">\n  <label [attr.for]=\"input.key\">{{ input.label }}</label>\n  <div\n    #summernote\n    class=\"form-control\"\n    clss=\"summernote\">{{ input.value }}</div>\n  <span\n    class=\"help-block text-muted\"\n    *ngIf=\"input.description!=''\"\n  >{{ input.description }}</span>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/tiny-mce/tiny-mce.component.html
// module id = 1259
// module chunks = 13